const a = {
  name: "orbit-camera",
  components: ["orbit-camera", "transform", "main-camera"]
};
export {
  a as orbitCameraRecipe
};
//# sourceMappingURL=recipes.js.map
